import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from '../../../Api/baseQueryWithReauth';
import { TagTypes } from '../../../Api/Types/tagTypes';
import type {
  GetUnreconciledInvoicesParams,
  GetUnreconciledInvoicesResult,
  ReconcileInvoicesCommand,
  ReconcileInvoicesResultDto,
  GetUnsettledBookingsAccountingReportParams,
  GetUnsettledBookingsAccountingReportResult,
  GetBookingUninvoicedReservationPaymentsReportParams,
  GetBookingUninvoicedReservationPaymentsReportResult,
} from '../Types/reports.types';

export const reportsApi = createApi({
  reducerPath: 'reportsApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: [TagTypes.ReportsList],
  endpoints: (builder) => ({
    getUnreconciledInvoices: builder.query<GetUnreconciledInvoicesResult, GetUnreconciledInvoicesParams>({
      query: (params) => ({
        url: '/invoices/reservation-payment-reconciliation',
        params,
      }),
      providesTags: [TagTypes.ReportsList],
    }),
    reconcileInvoices: builder.mutation<ReconcileInvoicesResultDto, ReconcileInvoicesCommand>({
      query: (body) => ({
        url: '/invoices/reconcile-from-reservation-payments',
        method: 'POST',
        body,
      }),
      invalidatesTags: [TagTypes.ReportsList],
    }),
    getUnsettledBookingsAccountingReport: builder.query<
      GetUnsettledBookingsAccountingReportResult,
      GetUnsettledBookingsAccountingReportParams
    >({
      query: (params) => ({
        url: '/bookings/accounting-settlement-report',
        params,
      }),
      providesTags: [TagTypes.ReportsList],
    }),
    getBookingUninvoicedReservationPaymentsReport: builder.query<
      GetBookingUninvoicedReservationPaymentsReportResult,
      GetBookingUninvoicedReservationPaymentsReportParams
    >({
      query: (params) => ({
        url: '/bookings/uninvoiced-reservation-payments-report',
        params,
      }),
      providesTags: [TagTypes.ReportsList],
    }),
  }),
});

export const {
  useGetUnreconciledInvoicesQuery,
  useReconcileInvoicesMutation,
  useGetUnsettledBookingsAccountingReportQuery,
  useGetBookingUninvoicedReservationPaymentsReportQuery,
} = reportsApi;
